module.exports = __webpack_public_path__ + "static/media/Icon awesome-minus.b263fde4.svg";